import React, { useState } from "react";
import "./style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from "react-router-dom";
import { useAddBillingAddressMutation } from "../../../services/myAccountAPI";
import { useGetColorThemeQuery } from "../../../services/commonAPI";

function BillingAddress() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    company_name: "",
    country: "",
    street_address: "",
    town_city: "",
    state: "",
    pin_code: "",
    phone: "",
    email: "",
  });

  const [addBillingAddress, { isLoading }] = useAddBillingAddressMutation();
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const { data: colorthemeData } = useGetColorThemeQuery();
  const handleBack = () => {
    navigate(-1);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage(null);
    setErrorMessage(null);

    try {
      const payload = { ...formData, user_id: id };

      const response = await addBillingAddress(payload).unwrap();

      if (response?.success) {
        setSuccessMessage("Billing address added successfully!");

        navigate("/my-account");
      } else {
        setErrorMessage(response.message || "Failed to add billing address.");
      }
    } catch (err) {
      console.error("Failed to add billing address:", err);

      // Check if validation errors exist
      if (err?.data?.message) {
        setErrorMessage(err.data.message);
      } else {
        setErrorMessage("Something went wrong while saving the address.");
      }
    }
  };

  return (
    <div className="billing-account-form">
      <div className="container">
        <div className="breadcrum text-start">
          <div className="row text-left">
            <div className="col-md-6 col-sm-12 col-lg-6">
              <p onClick={handleBack}>
                <FontAwesomeIcon icon={faAngleLeft} /> Back
              </p>
            </div>
          </div>
        </div>
        <h4>Billing Address</h4>

        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 col-sm-12 col-lg-6">
              <div className="mb-20">
                <label>First Name *</label>
                <input
                  type="text"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-6">
              <div className="mb-20">
                <label>Last Name *</label>
                <input
                  type="text"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="mb-20">
                <label>Company Name (Optional)</label>
                <input
                  type="text"
                  name="company_name"
                  value={formData.company_name}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="mb-20">
                <label>Country/Region</label>
                <input
                  type="text"
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="mb-20">
                <label>Street Address</label>
                <textarea
                  name="street_address"
                  rows="4"
                  value={formData.street_address}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="mb-20">
                <label>Town/City *</label>
                <input
                  type="text"
                  name="town_city"
                  value={formData.town_city}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="mb-20">
                <label>State *</label>
                <input
                  type="text"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="mb-20">
                <label>Zip Code *</label>
                <input
                  type="text"
                  name="pin_code"
                  value={formData.pin_code}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="mb-20">
                <label>Phone *</label>
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="mb-20">
                <label>Email Address *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="col-md-12">
              <button
                type="submit"
                className="primary-button"
                disabled={isLoading}
                style={{
                  backgroundColor:
                    colorthemeData?.color_themes?.[0]?.primary_color ||
                    "#a76d50",
                }}
              >
                {isLoading ? "Saving..." : "Save Address"}
              </button>
            </div>

            {/* Display Success Message */}
            {successMessage && (
              <p className="success-message" style={{ color: "green" }}>
                {successMessage}
              </p>
            )}

            {/* Display Error Message */}
            {errorMessage && (
              <p className="error-message" style={{ color: "red" }}>
                {errorMessage}
              </p>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default BillingAddress;
